const isObjEmpty = (o) => (
  (Object.keys(o).length === 0 && o.constructor === Object) || (Array.isArray(o) && o.length === 0)
)

export default isObjEmpty